/*
 * inner-circle-waitlist — staggered entrance reveal.
 * GSAP core + ScrollTrigger are global (theme.liquid); this just builds the timeline.
 * Reveals eyebrow -> headline -> supporting -> divider -> benefits -> divider -> form
 * -> microcopy in DOM order. Reduced-motion / no-GSAP -> everything visible at rest.
 */
(function () {
  var root = document.querySelector('.ic-waitlist');
  if (!root) return;
  var reveals = root.querySelectorAll('.ic__reveal');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
  }
  if (reduce || !window.gsap || !reveals.length) { showAll(); return; }

  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  if (ST) gsap.registerPlugin(ST);

  var tl = gsap.timeline({ paused: true });
  tl.fromTo(reveals, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out', stagger: 0.08 });

  if (ST) {
    ST.create({ trigger: root, start: 'top 70%', once: true, onEnter: function () { tl.play(); } });
  } else {
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) { if (e.isIntersecting) { tl.play(); obs.unobserve(root); } });
    }, { threshold: 0.15 });
    io.observe(root);
  }
})();
